<template>
    <div
        tabindex="0"
        @focus="focusOnFirstItem"
    >
        <ul
            v-show="list.length > 0"
            ref="list"
            class="overflow-auto py-0"
            @keydown.prevent.stop
            @keydown.down="moveFocus($event, 'down')"
            @keydown.up="moveFocus($event, 'up')"
            @blur="$emit('blur')"
            @focus="$emit('focus')"
        >
            <li
                v-for="(item, index) in list"
                :key="index"
                tabindex="0"
                class="text-truncate px-16 cursor--pointer text-dark"
                :class="item.checked && checkedClass"
                @click="select(item)"
                @keyup.enter="select(item)"
            >
                {{ item.text }}
            </li>
        </ul>

        <div
            v-if="options.length === 0 && !loading"
            class="bg-gray-light text-dark text-center py-16"
        >
            <v-icon
                name="info"
                :w="42"
            />

            <p>
                {{ ucfirst($t("validation.noResults")) }}
            </p>
        </div>
    </div>
</template>

<script>
import { ucfirst } from "~/lib/utils"

export default {
    props: {
        value: {
            type: [Array, String, Number],
            default: null,
        },

        options: Array,

        nullOption: {
            type: String,
        },

        loading: Boolean,
    },

    emits: ["blur", "focus", "update:value"],

    data() {
        return {
            focusedIndex: 0,
        }
    },

    computed: {
        list() {
            const list = this.options.map(option => {
                return Object.assign({}, option, {
                    checked: this.value === option.value,
                })
            })

            if (this.nullOption) {
                list.unshift({
                    checked: this.value === undefined || this.value === null,
                    text: this.nullOption,
                    value: null,
                })
            }
            return list
        },

        checkedClass() {
            const textPrimary = this.$css(
                this.$store.getters["theme/styles"].textPrimary
            )
            return [textPrimary, "font-weight-semi-bold"]
        },
    },

    methods: {
        focusOnFirstItem() {
            if (this.list.length == 0) return
            this.$refs.list.children[0].focus()
        },

        select(item) {
            this.$emit("update:value", item)
        },

        moveFocus(evt, direction) {
            let curr = evt.target
            let next =
                direction === "down" ? curr.nextSibling : curr.previousSibling
            if (next) {
                next.focus()
            }
        },

        ucfirst,
    },
}
</script>

<style lang="scss" scoped>
@import "~/scss/bootstrap-importable";

ul {
    padding: 2px 0; // Let people see focused element border top!
    list-style: none;
    user-select: none;
    max-height: 40vh;
}

li {
    padding: 1rem 0.75rem;
    outline: none;
}

li:hover,
li:focus,
li.disabled:active {
    background: $gray-light;
}
</style>
